<template>
<div class="projects-container">
	<div class="project-content">
		<div v-if="selectedProject==-1" class="projects-container">
			<!-- <div class="section-title">
				Research
			</div> -->
			<transition-group name="staggered-fade" tag="div" class="main-content" v-for="(projects, index) in filteredProjects" :id="projects.hash"  :key="index"> 
				<div v-if="index==0" class="section-title" :key="'label'+index">
					Research
				</div>
				<div v-else-if="index==getNumResearch" class="section-title" :key="'label'+index">
					Projects
				</div>
				<project-card
					v-on:changeSelectedProject="changeSelectedProject"
					:project="projects" :key="index">
				</project-card>
			</transition-group>
		</div>
	</div>
</div>
</template>
<script>
import projectData from '../assets/projects.json'
import ProjectCard from './ProjectCard'

export default {
	name: 'Projects',
	components: {
		'project-card': ProjectCard
	},
	data() {
		return {
			projectContainer: [],
			searchQuery: '',
			navMsg: 'Just a kid trying to build big things.',
			selectedProject: -1,
			numResearchItems: 0
		}
	},
	computed: {
		filteredProjects: function () {
           	return this.projectContainer.filter((project) => {
                return project.type === 'research' && project.title.toUpperCase().match(this.searchQuery.toUpperCase())
            })
        },
		getNumResearch: function() {
			return this.numResearchItems
		}
	},
	methods: {
		changeSelectedProject: function(event) {
			let projectKey = event;
			this.selectedProject = projectKey;
		},
		loadProjectData: function() {
			for (let index in projectData) {
				if (projectData[index]['type']=="research") {
					this.numResearchItems += 1
				}
				projectData[index]['subtitle'] = projectData[index]['subtitle'] ? projectData[index]['subtitle'] : ''
				projectData[index]['authors'] = projectData[index]['authors'] ? projectData[index]['authors'] : []
				this.projectContainer.push(
					{
						'title': projectData[index]['title'],
						'subtitle': projectData[index]['subtitle'],
						'authors': projectData[index]['authors'],
						'paper': projectData[index]['paper'],
						'url': projectData[index]['url'],
						'date': projectData[index]['date'],
						'imageSrc': projectData[index]['src'],
						'description': projectData[index]['desc'],
						'type': projectData[index]['type'],
						'hash': projectData[index]['hash']
					}
				)
			}

		},
		removeSearchQuery: function () {
            this.searchQuery = ''
            this.isProject = false
        },
        submitSearch: function () {
            this.isResult = true
            return this.filteredProjects
        },
        projectId: function(projectTitle) {
        	let elementId = '#' + projectTitle
        	return elementId
        }
	},
	created: function() {
		this.loadProjectData()
	}
};
</script>
<style scoped>
ul {
	list-style-type: none;
	padding: 0;
}
li {
	display: inline-block;
	margin: 0 10px;
}
/* @media only screen and (max-width: 900px){
	.table-contents-small .list-links {
		position: absolute;
		visibility: hidden;
		height: 0px;
		width: 0px;
	}
	.table-contents-small #search-bar {
		position: absolute;
		visibility: hidden;
		height: 0px;
		width: 0px;
	}

	.project-content .projects-container {
		display: block;
		width: 100%;
	}
} */
#search-bar {
	margin-bottom: 10px;
	outline: none;
}
.main-content {
	display: inline-block;
	width: 100%;
	margin-bottom: 16px;
}
.table-contents {
	display: inline-block;
	width: 10%;
	height: 100%;
	margin-right: 20px;
	font-size: 12px;
}

.section-title {
	font-size: 28px;
	font-weight: 600;
	text-align: left;
	margin: 4px 0 10px;
}

.projects-container {
	display: block;
	width: 100%;
	margin: auto;
}

.list-links {
	margin-bottom: 10px;
	text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Projects.vue